'use client';

import { c as _c } from "react/compiler-runtime";
import dynamic from 'next/dynamic';
import { useCallback, useEffect, useRef, useState } from 'react';
import { HotspotItem } from '@/app/lcv/components/sections/spartan/engine/sections/hero-animation/engine-story/hotspots/hotspot-item';
import type { HotspotsProps } from '@/app/lcv/components/sections/spartan/engine/sections/hero-animation/engine-story/hotspots/types';
import { SPARTAN_ENGINE_HERO_TRACKING } from '@/app/lcv/components/sections/spartan/engine/sections/hero-animation/tracking';
import styles from '@/app/lcv/components/sections/spartan/engine/styles.module.css';
import { cn } from '@/app/utils/cn';
import { createDataAttributes } from '@/app/utils/createDataAttributes';
const HotspotPopup = dynamic(() => import('@/app/lcv/components/sections/spartan/engine/sections/hero-animation/engine-story/hotspots/popup').then(module => module.HotspotPopup), {
  ssr: false
});
export const Hotspots = t0 => {
  const $ = _c(28);
  const {
    className,
    isActive: t1,
    hotspots: t2,
    onPopupOpenChange
  } = t0;
  const isActive = t1 === undefined ? false : t1;
  const hotspots = t2 === undefined ? [] : t2;
  const [selectedIndex, setSelectedIndex] = useState(null);
  let t3;
  let t4;
  if ($[0] !== isActive) {
    t3 = () => {
      if (!isActive) {
        setSelectedIndex(null);
      }
    };
    t4 = [isActive];
    $[0] = isActive;
    $[1] = t3;
    $[2] = t4;
  } else {
    t3 = $[1];
    t4 = $[2];
  }
  useEffect(t3, t4);
  const isPopupShown = selectedIndex !== null && !!isActive;
  const popupOpenChangeRef = useRef(onPopupOpenChange);
  let t5;
  if ($[3] !== onPopupOpenChange) {
    t5 = () => {
      popupOpenChangeRef.current = onPopupOpenChange;
    };
    $[3] = onPopupOpenChange;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  useEffect(t5);
  let t6;
  let t7;
  if ($[5] !== isPopupShown) {
    t6 = () => {
      popupOpenChangeRef.current?.(isPopupShown);
    };
    t7 = [isPopupShown];
    $[5] = isPopupShown;
    $[6] = t6;
    $[7] = t7;
  } else {
    t6 = $[6];
    t7 = $[7];
  }
  useEffect(t6, t7);
  let t8;
  let t9;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = () => () => popupOpenChangeRef.current?.(false);
    t9 = [];
    $[8] = t8;
    $[9] = t9;
  } else {
    t8 = $[8];
    t9 = $[9];
  }
  useEffect(t8, t9);
  const triggerRef = useRef(null);
  let t10;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = () => {
      setSelectedIndex(null);
      triggerRef.current?.focus({
        preventScroll: true
      });
    };
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  const handleAfterClose = t10;
  const t11 = !isActive;
  let t12;
  if ($[11] !== className || $[12] !== isActive) {
    t12 = cn("absolute inset-0", styles.hotspotArea, {
      [styles.hotspotAnimate]: isActive
    }, className);
    $[11] = className;
    $[12] = isActive;
    $[13] = t12;
  } else {
    t12 = $[13];
  }
  const t13 = "Hotspot Area";
  let t14;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = createDataAttributes({
      test: SPARTAN_ENGINE_HERO_TRACKING.hotspotArea
    });
    $[14] = t14;
  } else {
    t14 = $[14];
  }
  const t15 = hotspots.map((item, index) => <HotspotItem key={item.hotspotId} hotspotId={item.hotspotId} index={index} className={styles[item.hotspotId]} title={item.hotspotTitle ?? item.title} onClick={event => {
    triggerRef.current = event.currentTarget;
    setSelectedIndex(index);
  }} />);
  let t16;
  if ($[15] !== t11 || $[16] !== t12 || $[17] !== t14 || $[18] !== t15) {
    t16 = <div inert={t11} className={t12} aria-label={t13} {...t14}>{t15}</div>;
    $[15] = t11;
    $[16] = t12;
    $[17] = t14;
    $[18] = t15;
    $[19] = t16;
  } else {
    t16 = $[19];
  }
  let t17;
  if ($[20] !== handleAfterClose || $[21] !== hotspots || $[22] !== isPopupShown || $[23] !== selectedIndex) {
    t17 = !!isPopupShown && <HotspotPopup initialIndex={selectedIndex} hotspots={hotspots} onAfterClose={handleAfterClose} />;
    $[20] = handleAfterClose;
    $[21] = hotspots;
    $[22] = isPopupShown;
    $[23] = selectedIndex;
    $[24] = t17;
  } else {
    t17 = $[24];
  }
  let t18;
  if ($[25] !== t16 || $[26] !== t17) {
    t18 = <>{t16}{t17}</>;
    $[25] = t16;
    $[26] = t17;
    $[27] = t18;
  } else {
    t18 = $[27];
  }
  return t18;
};